export const epdValue = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '—';
  return typeof value === 'object' ? JSON.stringify(value) : String(value);
};

const record = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {};
const text = (value: unknown): string => (typeof value === 'string' ? value : '');

export const titleSigner = (value: Record<string, unknown> | null) => {
  const root = value || {};
  const signer = record(root.signer);
  const fio = record(root.ФИО);
  const poa = record(signer.poa);
  const fnsPoas = Array.isArray(root.СвДоверЭл) ? root.СвДоверЭл : [root.СвДоверЭл];
  return {
    name: [
      text(signer.last_name) || text(fio.Фамилия),
      text(signer.first_name) || text(fio.Имя),
      text(signer.middle_name) || text(fio.Отчество),
    ]
      .filter(Boolean)
      .join(' '),
    position: text(signer.position) || text(root.Должн),
    numbers: [text(poa.number), ...fnsPoas.map((item) => text(record(item).НомДовер))].filter(Boolean),
  };
};

export const operatorSeverity = (value?: string | null): 'error' | 'warning' | 'success' | 'info' => {
  const severity = value?.toLowerCase();
  return severity === 'error' || severity === 'warning' || severity === 'success' ? severity : 'info';
};
